import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomLeft12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconRadiusBottomLeft12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.8 3.19v3.238a3.5 3.5 0 0 0 3.5 3.5h3.366a.5.5 0 0 1 0 1H5.3a4.5 4.5 0 0 1-4.5-4.5V3.19a.5.5 0 0 1 1 0m7.696 5.005a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m.75-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-.75-1.5a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M5.797 1.017a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.974.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m5.199-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomLeft12);
